import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { SidebarNewProjectIcon } from '@/components/sidebar/sidebar-icons';
import { cn } from '@/lib/utils';
import { isInquirerAccount } from '@/lib/permissions';
import type { UserProps } from '@/lib/auth';

type DashboardSidebarCreateButtonProps = {
  user: UserProps | null | undefined;
  className?: string;
};

export function DashboardSidebarCreateButton({
  user,
  className,
}: DashboardSidebarCreateButtonProps) {
  const { t } = useTranslation();

  if (!isInquirerAccount(user ?? undefined)) {
    return null;
  }

  return (
    <div className={cn('px-2 group-data-[collapsible=icon]:flex group-data-[collapsible=icon]:justify-center', className)}>
      <Button
        asChild
        className="h-[35px] w-full rounded-md bg-brand-primary font-label text-white hover:bg-brand-primary-dark group-data-[collapsible=icon]:size-[35px] group-data-[collapsible=icon]:p-0"
      >
        <Link to="/llm-chat/new">
          <span className="flex items-center justify-center gap-2">
            <SidebarNewProjectIcon className="size-3.5 shrink-0" />
            <span className="group-data-[collapsible=icon]:hidden">{t('sidebar.newDecision')}</span>
          </span>
        </Link>
      </Button>
    </div>
  );
}

/** @deprecated Prefer DashboardSidebarCreateButton + Logo in AppSidebar */
export function DashboardSidebarFooter({
  user,
  className,
}: DashboardSidebarCreateButtonProps) {
  return <DashboardSidebarCreateButton user={user} className={className} />;
}
